<template>
	<div class="block_inp p-3">
		<div class="form-group mt-2">
			<label class="form-label" for="advanced_name">
				Назва
			</label>

			<div class="input-group flex-nowrap">
				<div class="input-group-prepend">
							<span class="input-group-text">
								<i class="fal  fa-typewriter fs-xl" ></i>
							</span>
				</div>
				<input id="advanced_name" type="text" class="form-control" v-model="question.name">
			</div>
		</div>

		<div class="form-group mt-4">
			<label class="form-label" >
				Привязка Uprox
			</label>

			<div class="" v-if="doors.length > 0">
				<v-select
					v-model="active_type"
					:reduce="active_type => active_type.token"
					class="imc_reasons"
					label="name"
					:options="this.doors"
					:filterable="false"
				>
					<template slot="no-options">
						Оберіть Тип(и)
					</template>

					<template slot="option"  slot-scope="option">
						<div class="d-center">
							{{ option.name }}
							<div>
								<small>
									{{ option.group_name }}
								</small>
							</div>
						</div>
					</template>
				</v-select>
			</div>
		</div>

		<div class="form-group mt-4">
			<label class="form-label" >
				Організація
			</label>

			<div class="" v-if="tovs.length > 0">
				<v-select
					:reduce="active_tov => active_tov.id"
					v-model="active_tov"
					class="imc_reasons"
					label="small_title"
					:options="this.tovs"
					:filterable="false"
				>
					<template slot="no-options">
						Оберіть Тип(и)
					</template>

					<template slot="option"  slot-scope="option">
						<div class="d-center">
							{{ option.small_title }}
						</div>
					</template>
				</v-select>
			</div>
		</div>

		<div class="form-group">
			<label class="form-label">
				Telegram Groups
			</label>
			<v-select class="imc_reasons" taggable multiple v-model="question.bot_groups"/>
		</div>
	</div>

</template>

<script>
import vSelect from 'vue-select';
export default {
	name: "camera_info",

	props : {
		question : {
			type : Object
		}
	},
	components : {
		vSelect
	},
	data () {
		return {
			doors : [],
			tovs : [],
			is_load : false,
		}
	},
	created() {
		this.load_os_tips();
		this.load_orgs();
	},

	methods : {
		async load_orgs() {
			this.tovs = [];
			await api.get('/organizations').then(({data}) => {
				if (data.status == "operation_success") {
					this.tovs = data.data;
				}
			}).catch(err => {
				EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
			});
		},

		async load_os_tips()  {
			this.doors = []
			await api.get('/uprox/doors').then(({data}) => {
				if (data.status == "operation_success") {
					this.doors = data.data;
				}
			}).catch(err => {
				EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
			});
		}
	},

	computed : {
		active_tov : {
			get :  function() {
				if(this.question.hasOwnProperty("tov_id")) {
					return parseInt(this.question.tov_id);
				}

				return 0;
			},

			set : function(val) {
				this.question.tov_id = val;
			}
		},

		active_type : {
			get :  function() {
				if(this.question.hasOwnProperty("uprox_device_token")) {
					return parseInt(this.question.uprox_device_token);
				}
				return null;
			},

			set : function(val) {
				if(val != null) {
					this.question.uprox_device_token = parseInt(val);
				}
				else {
					this.question.uprox_device_token = 0;
				}
			}
		},
	}
}
</script>

<style scoped>

</style>
